import axios from 'axios';
import { GenericDetailedError } from '~/errors/GenericDetailedError';

class LogsApiClass {
  async downloadLogs() {
    try {
      const body = (await axios.get('/api/downloadLogs')).data;
      const blob = new Blob([body], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = 'ServerLog';
      link.download = fileName;
      link.click();
    } catch (error: any) {
      throw new GenericDetailedError('Oväntat fel', error.message);
    }
  }
}

export const LogsApi = new LogsApiClass();
